import "@/assets/scss/app.scss";

import Vue from 'vue';

import '@/api/init';
import '@/utils/pnotify';
import '@/utils/errorHandler';

import App from '@/App';
import router from '@/router';
import store from '@/state/store';
import i18n from '@/i18n';

import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import ModalOTP from '@/utils/ModalOTP';

export const eventBus = new Vue();

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VeeValidate);
Vue.use(ModalOTP);

new Vue({
  router,
  store,
  i18n,
  eventBus,
  render: h => h(App),
}).$mount('#app');
